"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLimits(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "3 0 18 24" }, props),
        React.createElement("path", { d: "M18 17.769c0 2.336-.813 4.23-3.05 4.23L10.214 22c-1.566 0-2.635-1.924-3.945-3.353l-2.943-3.416a1.311 1.311 0 01.06-1.794 1.18 1.18 0 011.718.063L7 15.484V4a1 1 0 012 0v7.238a3.244 3.244 0 011.001-.215L10 3a1 1 0 012 0v7.999h1V4a1 1 0 012 0v7.001l.153.005c.308.017.591.075.848.168L16 7a1 1 0 012 0v10.769z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Limits')(SvgLimits);
//# sourceMappingURL=Limits.js.map